import {Course, SchoolClass} from "models"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import AppHistory from "shared/history"
import Button from "components/chalky-layout/button"
import ClockImage from "./clock.png"
import {digg} from "diggerize"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import {Image} from "react-native"
import {loading} from "components/layout/loading-blocker"
import React from "react"
import RenderHtml from "shared/render-html"
import RunningManImage from "./running-man.png"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceRecommendedCourse extends ShapeComponent {
  static propTypes = propTypesExact({
    course: PropTypes.instanceOf(Course).isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space"})

    this.t = t
  }

  render() {
    const {t} = this.tt
    const {course} = this.p
    const courseGroup = course.courseGroups().loaded()[0]
    const courseDescription = `<div style='color: #fff;'>${course.description()}</div>`

    return (
      <View style={this.recommendedContainerStyle ||= {flexDirection: "row", height: "100%"}}>
        <View>
          <Text style={this.recommendedForYourClassTitleStyle ||= {marginBottom: 20, color: "#fff", fontSize: 24}}>
            {t(".recommended_for_your_class")}
          </Text>
          <Text style={this.recommendedForYourClassCourseStyle ||= {color: "#fff", fontFamily: "DreamChaser", fontSize: 100, fontWeight: 400}}>
            {course.name()}
          </Text>
          {courseGroup &&
            <View style={this.courseTypeContainerStyle ||= {flexDirection: "row", alignItems: "center", marginTop: 23}}>
              {courseGroup.hasIcon() &&
                <Icon color="#fff" name={courseGroup.icon()} size={22} />
              }
              {!courseGroup.hasIcon() &&
                <Image source={RunningManImage} style={this.runningManImageStyle ||= {width: 32, height: 32}} />
              }
              <Text style={this.courseTypeTextStyle ||= {marginLeft: 24, color: "#fff", fontSize: 24, fontWeight: 700}}>
                {courseGroup.name()}
              </Text>
            </View>
          }
        </View>
        <View style={this.descriptionAndActionsViewStyle ||= {width: 720, marginLeft: "auto", marginRight: 80}}>
          <View style={this.courseDescriptionAndStartViewStyle ||= {minHeight: 200}}>
            <WithDefaultStyle
              style={this.courseDescriptiondefaultStyle ||= {
                Text: {
                  color: "#fff",
                  fontFamily: "HankenGrotesk",
                  fontSize: 24,
                  fontWeight: 400
                }
              }}
            >
              <RenderHtml source={courseDescription} />
            </WithDefaultStyle>
          </View>
          <View style={this.startClockContainerStyle ||= {flexDirection: "row", alignItems: "center", marginTop: 30}}>
            <Button
              dataSet={this.startButtonDataSet ||= {class: "start-button"}}
              onPress={this.tt.onStartPress}
              primary
              style={this.startButtonStyle ||= {marginRight: 24, paddingHorizontal: 42, paddingVertical: 15, borderRadius: 36}}
              textStyle={this.startButtonTextStyle ||= {fontFamily: "HankenGrotesk", fontSize: 24, fontWeight: 600}}
              title={t(".start")}
            />
            {course.hasEstimatedTime() &&
              <>
                <Image source={ClockImage} style={this.clockImageStyle ||= {width: 48, height: 48}} />
                <Text style={this.xMinutesStyle ||= {color: "#fff", fontSize: 24}}>
                  {course.estimatedTime()}
                </Text>
              </>
            }
          </View>
        </View>
      </View>
    )
  }

  onStartPress = async () => {
    const {course, schoolClass} = this.p

    await loading(null, async () => {
      const result = await course.takeOrContinue({school_class_id: schoolClass.id()})
      const url = digg(result, "url")

      AppHistory.push(url)
    })
  }
}))
